import React from 'react';
import Category from '../models/Category';
import BlogSections from '../BlogSections';
import { blogEndpoint } from '../Blog';
import Link from '@/components/Link';

interface CategoryLinkProps {
  category: Category;
  className?: string;
  upperCase?: boolean;
}

export default class CategoryLink extends React.PureComponent<CategoryLinkProps> {
  render() {
    const title = this.props.upperCase ? this.props.category.name.toUpperCase() : this.props.category.name;
    const pageSlug = this.props.category.slug;
    const taxonomy = this.props.category.taxonomy;
    return (
      <Link href={`/${blogEndpoint}/${BlogSections.generalResults}/${taxonomy}/${pageSlug}`}>
        <a className={'category-link ' + (this.props.className || '')}>
          <span>{title}</span>
        </a>
      </Link>
    );
  }
}
